export const FETCH_QUICK_CODES = "[RECEPTIONIST] FETCH_QUICK_CODES";
export const FETCH_QUICK_CODES_START = "[RECEPTIONIST] FETCH_QUICK_CODES_START";
export const FETCH_QUICK_CODES_SUCCESS = "[RECEPTIONIST] FETCH_QUICK_CODES_SUCCESS";
export const FETCH_QUICK_CODES_ERROR = "[RECEPTIONIST] FETCH_QUICK_CODES_ERROR";
export const SET_QUICK_CODES_PAGINATION = "SET_QUICK_CODES_PAGINATION";

export const ADD_UPDATE_QUICK_CODE = "[RECEPTIONIST] ADD_UPDATE_QUICK_CODE";
export const ADD_UPDATE_QUICK_CODE_START = "[RECEPTIONIST] ADD_UPDATE_QUICK_CODE_START";
export const ADD_UPDATE_QUICK_CODE_SUCCESS = "[RECEPTIONIST] ADD_UPDATE_QUICK_CODE_SUCCESS";
export const ADD_UPDATE_QUICK_CODE_ERROR = "[RECEPTIONIST] ADD_UPDATE_QUICK_CODE_ERROR";

export const FETCH_QUICK_CODES_BY_ID = "[RECEPTIONIST] FETCH_QUICK_CODES_BY_ID";
export const FETCH_FETCH_QUICK_CODES_BY_ID_START = "[RECEPTIONIST] FETCH_QUICK_CODES_BY_ID_START";
export const FETCH_FETCH_QUICK_CODES_BY_ID_SUCCESS = "[RECEPTIONIST] FETCH_QUICK_CODES_BY_ID_SUCCESS";
export const FETCH_FETCH_QUICK_CODES_BY_ID_ERROR = "[RECEPTIONIST] FETCH_QUICK_CODES_BY_ID_ERROR";

export const fetchQuickCodes = (payload) => {
    return {
        type: FETCH_QUICK_CODES,
        payload
    }
}

export const addUpdateQuickCodes = (quickcode) => {
    return {
        type: ADD_UPDATE_QUICK_CODE,
        quickcode
    }
}

export const fetchQuickCodesbyId = (quickcodeId) => {
    return {
        type: FETCH_QUICK_CODES_BY_ID,
        payload: { quickcodeId }
    }
}